import _supplierInvoiceApi from './_supplierInvoiceApi';

class supplierInvoiceApi extends _supplierInvoiceApi {
  controllerName = 'SupplierInvoiceBots';
}

export default new supplierInvoiceApi();
